// import React, { useState, useMemo } from "react";
// import { motion } from "framer-motion";
// import { FaPlus, FaMinus, FaArrowRight } from "react-icons/fa";
// import faqCategories from "./Categories/category";
// import "./FAQ.css";

// function FAQSection() {

//   // DEFAULT TAB
//   const [selectedType, setSelectedType] = useState("event");

//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [openIndex, setOpenIndex] = useState(null);
//   const [visibleCount, setVisibleCount] = useState(3);

//   const handleTypeSelect = (type) => {
//     setSelectedType(type);
//     setSelectedCategory(null);
//     setOpenIndex(null);
//     setVisibleCount(3);
//   };

//   const handleCategoryClick = (category) => {
//     setSelectedCategory(category);
//     setOpenIndex(null);
//     setVisibleCount(3);
//   };

//   const handleBackToCategories = () => {
//     setSelectedCategory(null);
//     setOpenIndex(null);
//     setVisibleCount(3);
//   };

//   const toggleAnswer = (index) =>
//     setOpenIndex(openIndex === index ? null : index);

//   const faqSchema = useMemo(() => {
//     if (!selectedCategory) return null;

//     return {
//       "@context": "https://schema.org",
//       "@type": "FAQPage",
//       mainEntity: selectedCategory.questions.map((q) => ({
//         "@type": "Question",
//         name: q.question,
//         acceptedAnswer: {
//           "@type": "Answer",
//           text: q.answer,
//         },
//       })),
//     };
//   }, [selectedCategory]);

//   // FAQ DATA
//   const faqData = selectedCategory?.questions || [];
//   const visibleFaqs = faqData.slice(0, visibleCount);

//   const handleLoadMore = () =>
//     setVisibleCount((prev) =>
//       Math.min(prev + 3, faqData.length)
//     );

//   const handleShowLess = () => setVisibleCount(3);

//   return (
//     <>
//       {faqSchema && (
//         <script
//           type="application/ld+json"
//           dangerouslySetInnerHTML={{
//             __html: JSON.stringify(faqSchema),
//           }}
//         />
//       )}

//       <motion.div className="faq-container">

//         {/* MAIN HEADING */}
//         <h2 className="faq-main-heading">
//           Frequently Asked Questions
//         </h2>

//         <p className="faq-intro">
//           Browse FAQs related to travel and event management services.
//         </p>

//         {/* TABS */}
//         <div className="faq-type-buttons">

//           <button
//             className={`faq-type-btn ${
//               selectedType === "event"
//                 ? "active-tab"
//                 : ""
//             }`}
//             onClick={() => handleTypeSelect("event")}
//           >
//             Events
//           </button>

//           <button
//             className={`faq-type-btn ${
//               selectedType === "travel"
//                 ? "active-tab"
//                 : ""
//             }`}
//             onClick={() => handleTypeSelect("travel")}
//           >
//             Travel
//           </button>

//         </div>

//         {/* CATEGORY LIST */}
//         {!selectedCategory && (
//           <div className="faq-category-list">

//             {faqCategories[selectedType].map((cat) => (
//               <div
//                 key={cat.id}
//                 className="faq-category-item"
//                 onClick={() =>
//                   handleCategoryClick(cat)
//                 }
//               >
//                 <h3 className="faq-category-title">
//                   {cat.title}
//                 </h3>

//                 <FaArrowRight
//                   size={16}
//                   className="faq-arrow"
//                 />
//               </div>
//             ))}

//           </div>
//         )}

//         {/* FAQ SECTION */}
//         {selectedCategory && (
//           <>

//             <h2 className="faq-category-heading">
//               {selectedCategory.title}
//             </h2>

//             <div className="faq-list">

//               {visibleFaqs.map((item, index) => (
//                 <div
//                   key={index}
//                   className="faq-item"
//                 >

//                   <div
//                     className="faq-question"
//                     onClick={() =>
//                       toggleAnswer(index)
//                     }
//                   >
//                     <h3 className="faq-question-title">
//                       {item.question}
//                     </h3>

//                     <span className="faq-icon">
//                       {openIndex === index
//                         ? <FaMinus />
//                         : <FaPlus />}
//                     </span>
//                   </div>

//                   {openIndex === index && (
//                     <div className="faq-answer">
//                       <p>{item.answer}</p>
//                     </div>
//                   )}

//                 </div>
//               ))}

//             </div>

//             <div className="faq-buttons">

//               <button
//                 className="faq-load-more"
//                 onClick={handleBackToCategories}
//               >
//                 ← Back
//               </button>

//               {visibleCount < faqData.length && (
//                 <button
//                   className="faq-load-more"
//                   onClick={handleLoadMore}
//                 >
//                   Load More
//                 </button>
//               )}

//               {visibleCount > 3 && (
//                 <button
//                   className="faq-show-less"
//                   onClick={handleShowLess}
//                 >
//                   Show Less
//                 </button>
//               )}

//             </div>

//           </>
//         )}

//       </motion.div>
//     </>
//   );
// }

// export default FAQSection;


import React, { useState, useMemo } from "react";
import { motion } from "framer-motion";
import {
  FaPlus,
  FaMinus,
  FaArrowRight,
  FaSearch,
} from "react-icons/fa";

import faqCategories from "./Categories/category";
import "./FAQ.css";

function FAQSection() {

  // DEFAULT TAB
  const [selectedType, setSelectedType] = useState("event");

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [visibleCount, setVisibleCount] = useState(3);

  // SEARCH
  const [searchTerm, setSearchTerm] = useState("");

  const handleTypeSelect = (type) => {
    setSelectedType(type);
    setSelectedCategory(null);
    setOpenIndex(null);
    setVisibleCount(3);
    setSearchTerm("");
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setOpenIndex(null);
    setVisibleCount(3);
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
    setOpenIndex(null);
    setVisibleCount(3);
  };

  const toggleAnswer = (index) =>
    setOpenIndex(openIndex === index ? null : index);

  // SEARCH RESULTS
  const searchResults = useMemo(() => {

    if (!searchTerm.trim()) return [];

const allQuestions =
  Object.entries(faqCategories).flatMap(
    ([type, categories]) =>
      categories.flatMap((cat) =>
        cat.questions.map((q) => ({
          ...q,
          category: cat.title,
          type,
        }))
      )
  );

    return allQuestions.filter((item) =>
      item.question
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );

  }, [searchTerm, selectedType]);

  const faqSchema = useMemo(() => {

    if (!selectedCategory) return null;

    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: selectedCategory.questions.map((q) => ({
        "@type": "Question",
        name: q.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: q.answer,
        },
      })),
    };

  }, [selectedCategory]);

  // FAQ DATA
  const faqData = selectedCategory?.questions || [];

  const visibleFaqs = faqData.slice(0, visibleCount);

  const handleLoadMore = () =>
    setVisibleCount((prev) =>
      Math.min(prev + 3, faqData.length)
    );

  const handleShowLess = () => setVisibleCount(3);

  return (
    <>
      {faqSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqSchema),
          }}
        />
      )}

      <motion.div className="faq-container">

        {/* HEADING */}
        <h2 className="faq-main-heading">
          Frequently Asked Questions
        </h2>

        <p className="faq-intro">
          Browse FAQs related to travel and event
          management services.
        </p>

    

        {/* SEARCH BAR */}
        <div className="faq-search-wrapper">

          <FaSearch className="faq-search-icon" />

          <input
            type="text"
            placeholder="Search FAQs..."
            className="faq-search-input"
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(e.target.value)
            }
          />

        </div>
            {/* TABS */}
        <div className="faq-type-buttons">

          <button
            className={`faq-type-btn ${
              selectedType === "event"
                ? "active-tab"
                : ""
            }`}
            onClick={() => handleTypeSelect("event")}
          >
            Events
          </button>

          <button
            className={`faq-type-btn ${
              selectedType === "travel"
                ? "active-tab"
                : ""
            }`}
            onClick={() => handleTypeSelect("travel")}
          >
            Travel
          </button>

        </div>

        {/* SEARCH RESULTS */}
        {searchTerm.trim() ? (

          <div className="faq-list">

            {searchResults.length > 0 ? (

              searchResults.map((item, index) => (
                <div
                  key={index}
                  className="faq-item"
                >

                  <div
                    className="faq-question"
                    onClick={() =>
                      toggleAnswer(index)
                    }
                  >

                    <div>

                      <span className="faq-search-category">
                        {item.category}
                      </span>

                      <h3 className="faq-question-title">
                        {item.question}
                      </h3>

                    </div>

                    <span className="faq-icon">
                      {openIndex === index
                        ? <FaMinus />
                        : <FaPlus />}
                    </span>

                  </div>

                  {openIndex === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}

                </div>
              ))

            ) : (

              <p className="faq-no-results">
                No FAQs found.
              </p>

            )}

          </div>

        ) : (
          <>
            {/* CATEGORY LIST */}
            {!selectedCategory && (
              <div className="faq-category-list">

                {faqCategories[selectedType].map(
                  (cat) => (
                    <div
                      key={cat.id}
                      className="faq-category-item"
                      onClick={() =>
                        handleCategoryClick(cat)
                      }
                    >
                      <h3 className="faq-category-title">
                        {cat.title}
                      </h3>

                      <FaArrowRight
                        size={16}
                        className="faq-arrow"
                      />
                    </div>
                  )
                )}

              </div>
            )}

            {/* FAQ SECTION */}
            {selectedCategory && (
              <>

                <h2 className="faq-category-heading">
                  {selectedCategory.title}
                </h2>

                <div className="faq-list">

                  {visibleFaqs.map(
                    (item, index) => (
                      <div
                        key={index}
                        className="faq-item"
                      >

                        <div
                          className="faq-question"
                          onClick={() =>
                            toggleAnswer(index)
                          }
                        >
                          <h3 className="faq-question-title">
                            {item.question}
                          </h3>

                          <span className="faq-icon">
                            {openIndex === index
                              ? <FaMinus />
                              : <FaPlus />}
                          </span>
                        </div>

                        {openIndex === index && (
                          <div className="faq-answer">
                            <p>{item.answer}</p>
                          </div>
                        )}

                      </div>
                    )
                  )}

                </div>

                <div className="faq-buttons">

                  <button
                    className="faq-load-more"
                    onClick={
                      handleBackToCategories
                    }
                  >
                    ← Back
                  </button>

                  {visibleCount <
                    faqData.length && (
                    <button
                      className="faq-load-more"
                      onClick={handleLoadMore}
                    >
                      Load More
                    </button>
                  )}

                  {visibleCount > 3 && (
                    <button
                      className="faq-show-less"
                      onClick={handleShowLess}
                    >
                      Show Less
                    </button>
                  )}

                </div>

              </>
            )}
          </>
        )}

      </motion.div>
    </>
  );
}

export default FAQSection;